import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-velvet text-parchment/80 relative overflow-hidden">
      <div className="hairline-gold" />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="/vivant-monogram.png" alt="VIVANT" className="h-11 w-11 object-contain" />
            <div className="font-display text-2xl tracking-[0.35em] text-parchment">VIVANT</div>
          </div>
          <p className="font-serif text-2xl leading-snug text-gold/90 max-w-sm">
            La culture ne se génère pas.
          </p>
          <p className="mt-3 text-sm text-parchment/60 max-w-sm">
            Intimate, host-led evenings inside the castles, estates and hidden houses of Paris and its countryside.
          </p>
        </div>
        <div>
          <h4 className="eyebrow mb-4">Discover</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/#evenings" className="link-underline">Upcoming evenings</Link></li>
            <li><Link to="/#how" className="link-underline">How it works</Link></li>
            <li><Link to="/#manifesto" className="link-underline">Our manifesto</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="eyebrow mb-4">Partners</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/host" className="link-underline">Host with us</Link></li>
            <li><a href="mailto:hello@vivant.paris" className="link-underline">hello@vivant.paris</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-parchment/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-parchment/40">
          <span>© {new Date().getFullYear()} VIVANT · Paris</span>
          <span>Book · Get the address · Show up</span>
        </div>
      </div>
    </footer>
  );
}
